export const CONTACT_INFO = {
  phone: "20949740",
  phoneFormatted: "+45 20 94 97 40",
  email: "kontakt@nsts.dk",
  address: "Esrumvej 335, 3000 Helsingør",
  cvr: "36175990",
  companyName: "Nordsjællands Tømrer og Snedker",
  shortName: "NSTS",
  location: "Helsingør & Nordsjælland"
};

export const IMAGES = {
  logo: "https://assets.auxodev.dk/assets/bf156273-6242-48dd-a9a0-7699f46947d9/49ee54dd-ba5f-4bd1-8fc5-573961f3a12b.png",
  hero: "https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/img-1991.jpeg",
  toemrer: "https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/gra-n-karnap.jpg",
  terrasse: "https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/terrasse.jpeg",
  tag: "https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/tagarbejde.jpg",
  omos: "https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/20251215-123212.jpg",
  murer: "https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/murerarbejde.jpg",
  belaegning: "https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/fliselaegning-terrasse.jpg"
};

export const GALLERIES = {
  toemrerarbejde: [
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/pra-cisionsarbejde.jpeg",
      title: "Præcisionsarbejde",
      desc: "Opmåling og tilpasning af spær og konstruktioner."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/snedkerarbejde.jpg",
      title: "Snedkerarbejde",
      desc: "Specialfremstillet snedkerarbejde og detaljer i højeste kvalitet."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/tilbygning.jpg",
      title: "Tilbygning",
      desc: "Flot og moderne tilbygning udført med sans for detaljen."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/vinduer-og-da-re.jpg",
      title: "Vinduer og døre",
      desc: "Montering og udskiftning af døre og vinduer med millimeterpræcision."
    }
  ],
  terrasse: [
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/cumaro.jpg",
      title: "Cumaro",
      desc: "Eksklusiv og slidstærk terrasse i smukt Cumaro hårdttræ."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/jatoba.jpeg",
      title: "Jatoba",
      desc: "Elegant terrasse i Jatoba hårdttræ med en varm, rødbrun glød."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/la-rketra.jpeg",
      title: "Lærketræ",
      desc: "Klassisk og holdbar træterrasse opbygget i lærketræ."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/trykimpra-gneret.jpg",
      title: "Trykimprægneret",
      desc: "Solid og funktionel terrasse i klassisk trykimprægneret fyrretræ."
    }
  ],
  tagarbejde: [
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/ba-lgeeternit.jpg",
      title: "Bølgeeternit",
      desc: "Klassisk og robust bølgeeternit tagdækning."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/lettegl-dyb-sort.jpg",
      title: "Lettegl Dyb sort",
      desc: "Elegant og let tagløsning i dyb sort farve."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/listeda-kning.jpg",
      title: "Listedækning",
      desc: "Flot listedækning med rene linjer og høj tæthed."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/skiferengoberet-tegl.jpg",
      title: "Skiferengoberet tegl",
      desc: "Eksklusiv skiferengoberet overflade med flot glans."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/sort-engoberet-flad-falstagsten.jpg",
      title: "Sort engoberet flad falstagsten",
      desc: "Moderne, flad falstagsten med engoberet finish."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/s-profileret-tegltag.jpg",
      title: "S-profileret tegltag",
      desc: "Traditionelt S-profileret tegltag med smukke kurver."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/vingetegl_1.jpg",
      title: "Vingetegl",
      desc: "Klassisk vingetegl med smuk, traditionel profil."
    }
  ],
  murerbelaegning: [
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/image000000-18.jpg",
      title: "Badeværelse",
      desc: "Eksklusivt flisearbejde og murerarbejde på badeværelse."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/brostensbela-gning.jpg",
      title: "Brostensbelægning",
      desc: "Flot og klassisk brostensbelægning udført med præcision."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/fliser.jpg",
      title: "Flisebelægning",
      desc: "Professionel fliselægning til terrasse eller indkørsel."
    },
    {
      url: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/gasbeton.jpg",
      title: "Gasbeton",
      desc: "Opbygning og murerarbejde i gasbeton."
    }
  ]
};

export const SERVICES = [
  {
    id: "toemrerarbejde",
    title: "Tømrerarbejde",
    path: "/toemrerarbejde",
    icon: "Hammer",
    shortDesc: "Alt i traditionelt og moderne tømrerarbejde. Vi har stor erfaring med store tilbygninger, ombygninger samt renovering.",
    image: IMAGES.toemrer,
    bullets: [
      "Nybyggeri & Tilbygninger",
      "Renovering & Vedligeholdelse",
      "Døre & Vinduer",
      "Snedkerdetaljer & Specialmål"
    ]
  },
  {
    id: "terrasse",
    title: "Terrasse",
    path: "/terrasse",
    icon: "Layers",
    shortDesc: "Specialdesignede træterrasser i eksklusive materialer. Vi skaber dit nye uderum med fokus på detaljen og en flot finish.",
    image: IMAGES.terrasse,
    bullets: [
      "Eksklusive træsorter (Ceder, Ipe, Thermo)",
      "Skjult skruemontage",
      "Integrerede trapper & niveauer",
      "Solidt underbygningsarbejde"
    ]
  },
  {
    id: "tagarbejde",
    title: "Tagarbejde",
    path: "/tagarbejde",
    icon: "Home",
    shortDesc: "Nyt tag og tagrenovering, der sikrer din bolig mod vind og vejr i mange årtier fremover.",
    image: IMAGES.tag,
    bullets: [
      "Nyt tag (Tegl, Beton, Skifer)",
      "Tagrenovering & Reparation",
      "Efterisolering af tagrum",
      "Montering af tagvinduer"
    ]
  },
  {
    id: "murer-belaegning",
    title: "Murer & Belægning",
    path: "/murer-belaegning",
    icon: "Grid",
    shortDesc: "Professionelt murerarbejde og flisebelægning. Vi udfører alt fra badeværelser og facaderenovering til indkørsler og terrasser.",
    image: IMAGES.murer,
    bullets: [
      "Flisepålægning & Terrasser",
      "Murerarbejde & Facaderenovering",
      "Støbning af fundamenter",
      "Badeværelser & Flisearbejde"
    ]
  }
];

export const REVIEWS = [
  {
    name: "Morten Hansen",
    location: "Helsingør",
    text: "NSTS har bygget vores nye træterrasse i cedertræ. Resultatet er helt fantastisk. Præcisionen i hjørnerne og de skjulte skruer vidner om ægte snedkerkvalitet. Kan varmt anbefales!",
    rating: 5
  },
  {
    name: "Sofie & Christian",
    location: "Hornbæk",
    text: "Fik lavet komplet tagrenovering med nye tagrender i kobber. NSTS leverede til tiden, holdt byggepladsen ryddelig og rådgav os professionelt hele vejen igennem. Meget troværdig tømrer.",
    rating: 5
  },
  {
    name: "Jens Jensen",
    location: "Snekkersten",
    text: "Super professionelt tømrerarbejde i forbindelse med vores nye tilbygning. Flotte detaljer og solidt håndværk. NSTS er vores faste tømrer fremover.",
    rating: 5
  },
  {
    name: "Anette Poulsen",
    location: "Humlebæk",
    text: "Vi fik udskiftet alle døre og vinduer i vores parcelhus. NSTS leverede et utrolig flot stykke arbejde, og finishen er helt i top. De var yderst professionelle og høflige.",
    rating: 5
  },
  {
    name: "Thomas Nielsen",
    location: "Helsingør",
    text: "Fremragende service og rådgivning. Vi fik renoveret vores førstesal med nye gipsvægge og lofter. Alt blev udført præcist som aftalt og til den aftalte pris.",
    rating: 5
  },
  {
    name: "Lene & Peter",
    location: "Hornbæk",
    text: "Vores nye tagterrasse står fuldstændig som drømt om. NSTS har været en fornøjelse at samarbejde med fra start til slut. Deres sans for detaljer er uovertruffen.",
    rating: 5
  }
];

export const FALLBACK_PROJECTS = [
  {
    id: "632188b4-2554-4d32-9875-ca4bba7e4e8c",
    title: "Opførelse af skur i vedligeholdelsesfrit hardiplank",
    description: "",
    category: "Tømrerarbejde",
    location: "Helsingør",
    year: 2026,
    image: ["https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/ta-mrerarbejde.jpeg"]
  },
  {
    id: "7665691f-76bc-4e91-8ad2-5b3fc99d9390",
    title: "Ny terrasse i hårdtræ",
    description: "",
    category: "Terrasse",
    location: "Helsingør",
    year: 2025,
    image: ["https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/resized-20220808-165250.jpeg"]
  },
  {
    id: "95767e69-8c3b-4e90-aed1-fa95e65e2183",
    title: "Tagrenovering af snedkerhal i bølgeeternit",
    description: "",
    category: "Tagarbejde",
    location: "Helsingør",
    year: 2026,
    image: ["https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/tagarbejde_2.jpg"]
  },
  {
    id: "e287774a-2ba0-4ce4-be23-1cd71a275b7b",
    title: "Renovering af badeværelse",
    description: "",
    category: "Murerarbejde",
    location: "Helsingør",
    year: 2026,
    image: ["https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/image000000-18.jpg"]
  }
];
